import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { confirmBarber } from './actions';
import ConfirmBarber from './components/ConfirmBarber';

class ConfirmBarberContainer extends Component {
  componentDidMount() {
    this.props.confirmBarber();
  }

  render() {
    return (
      <ConfirmBarber
        isFetching={this.props.isFetching}
        successMessage={this.props.successMessage}
        errorMessage={this.props.errorMessage}
      />
    );
  }
}
ConfirmBarberContainer.propTypes = {
  confirmBarber: PropTypes.func.isRequired,
  isFetching: PropTypes.bool,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
};
ConfirmBarberContainer.defaultProps = {
  isFetching: false,
  successMessage: '',
  errorMessage: '',
};

const mapStateToProps = state => ({
  isFetching: state.confirmation.get('isFetching'),
  errorMessage: state.confirmation.get('errorMessage'),
  successMessage: state.confirmation.get('successMessage'),
});

const mapDispatchToProps = (dispatch, ownProps) => bindActionCreators({
  confirmBarber: confirmBarber.bind(null, ownProps.params.shopId, ownProps.params.barberId),
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmBarberContainer);



// WEBPACK FOOTER //
// ./src/app/confirmation/ConfirmBarber.jsx